import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select/src/tom-select.popular'
import { TomInput, TomOption } from 'tom-select/src/types'
import { escape_html } from 'tom-select/src/utils'

export default class extends Controller {
  static values = {
    placeholder: { type: String, default: '' }
  }

  declare placeholderValue: string
  plugin: TomSelect

  connect (): void {
    const placeholder = this.placeholderText()

    this.plugin = new TomSelect(this.element as TomInput, {
      allowEmptyOption: true,
      closeAfterSelect: true,
      items: [],
      maxOptions: 99999,
      placeholder,
      render: {
        option: (data: TomOption, escape: typeof escape_html) => this.renderOption(data, escape),
        item: (data: TomOption, escape: typeof escape_html) => this.renderItem(data, escape)
      }
    })

    const origOnOptionSelect = this.plugin.onOptionSelect.bind(this.plugin)
    this.plugin.hook('instead', 'onOptionSelect', (evt: MouseEvent, option: HTMLElement) => {
      if (option.dataset.value === '') {
        this.plugin.clear(true)
        this.plugin.close()
        ;(this.element as HTMLSelectElement).dispatchEvent(new Event('change', { bubbles: true }))
        return
      }

      origOnOptionSelect(evt, option)
    })

    ;(this.element as HTMLElement & { tomSelect?: TomSelect }).tomSelect = this.plugin
    this.plugin.control.classList.add('flex-nowrap')
  }

  disconnect (): void {
    if (!document.body.contains(this.element)) {
      this.plugin?.destroy()
    }
  }

  private placeholderText (): string {
    const element = this.element as HTMLSelectElement

    if (this.placeholderValue !== '') return this.placeholderValue

    const dataPlaceholder = element.getAttribute('data-placeholder') ?? ''
    if (dataPlaceholder !== '') return dataPlaceholder

    const datasetPlaceholder = element.dataset.placeholder ?? ''
    if (datasetPlaceholder !== '') return datasetPlaceholder

    return ''
  }

  private renderOption (data: TomOption, escape: typeof escape_html): string {
    if (data.value === '') {
      return '<div class="w-full"><p class="invisible" aria-hidden="true">&nbsp;</p></div>'
    }

    return `<div class="w-full"><p>${escape(data.text)}</p></div>`
  }

  private renderItem (data: TomOption, escape: typeof escape_html): string {
    if (data.value === '') return ''

    return `<div class="w-fit max-w-full"><p class="truncate">${escape(data.text)}</p></div>`
  }
}
